import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { ClientsV2Service } from '@wilson/clients/services';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BaseSelectFilterDirective } from '../../base-select-filter.directive';
import { FilterService } from '../../filter.service';
import { MultiSelectParserService } from '../../services/multi-select-parser.service';
import { FilterOptions } from '../../options.interface';

@Component({
  selector: 'wilson-shared-user-qualification-v2-partner-filter',
  templateUrl: './shared-user-qualification-v2-partner-filter.component.html',
  styleUrls: ['./shared-user-qualification-v2-partner-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NzSelectModule, TranslatePipe, CommonModule, FormsModule],
})
export class SharedUserQualificationV2PartnerFilterComponent extends BaseSelectFilterDirective<
  FilterOptions,
  string[]
> {
  protected readonly filterService = inject(FilterService);
  protected readonly parserService = inject(MultiSelectParserService);
  private readonly clientsV2Service = inject(ClientsV2Service);

  constructor() {
    super('sharedUserQualificationV2Partner');
  }

  protected initializeOptions(): Observable<FilterOptions[]> {
    return this.clientsV2Service
      .findAll({
        relations: ['clientPartnership'],
        limit: 0,
      })
      .pipe(
        map((clients) => {
          return clients.data
            .filter(
              (client) => client.id !== undefined && client.clientPartnership,
            )
            .map((client) => ({
              id: client.clientPartnership?.partnershipId as string,
              name: client.clientPartnership?.partnerName as string,
            }));
        }),
        catchError(() => of([])),
      );
  }
}
